import React, { useState, useEffect, useMemo, useCallback } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../services/supplier_appCommonService";
// import CommLineItemTable from "../../../../Components/PivotTable/CommLineItemTable";
import CommLineItemTablePO from "./CommLineItemTablePO";

//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
// import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import {
  getCurrentDate,
  isValidNumber,
  // isValidNumber,
  // validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import SericesSchedulePO from "../../../../Components/Modal/supplier_app/PO_Collabration/SericesSchedulePO";
import Loader from "../../../../Components/Loader";
import {
  getpurchaseGroup1,
  getCostCenterOptions,
  getGLAccountOptions,
  getPriorityOptions,
  getBusinessUnitOptions,
  getDeliveryAddressOptions,
} from "../PR/PRConstant";

const PurchaseRequisitionCreationPR = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "");

  let purchaseDocType = useSelector(
    (state) => state?.purchasing.purchaseDocType,
  );
  let purchaseDocCode = useSelector(
    (state) => state?.purchasing.purchaseDocCode,
  );
  let userData = useSelector((state) => state?.user);
  // User Details from Store
  let awardQuotationNr = useSelector(
    (state) => state?.sourcing?.rfq?.awardQuotationNr,
  );

  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr);
  // User Details from Store
  //  let workflowConfig = useSelector((state) => state?.common?.data?.workflow); // workflowConfig Details from Store
  //  let sourcingConfig = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store
  //  let workflow = useSelector((state) => state?.sourcing?.rfq?.workflowCOMM); // workflowTECH from Store
  //  let evaluationCriteriaData = useSelector(
  //    (state) =>
  //      state?.common?.data?.sourcing?.CommercialEvaluation?.EvaluationCriteria
  //  );

  let processOptions = [
    {
      id: "1",
      name: "ASN",
      code: "ASN",
      description: "ASN",
    },
    {
      id: "2",
      name: "GRN",
      code: "GRN",
      description: "GRN",
    },
  ];

  const [currentDate] = useState(getCurrentDate("default"));
  // JSON Object
  const [formInputs, setFormInputs] = useState({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    // purchasingDocumentType: purchaseDocType,
    purchasingReqDocumentType: purchaseDocType,
    purchasingDocumentCode: purchaseDocCode,
    version: "V0",
    statusHeader: "In Release",
    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingDocumentCategory: "L",
    purchasingDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsLocation: "",
    purchasingDocumentValue: "",
    purchasingRemark: "",
    purchasingReqRemark: "",
    purchasingReqDocumentValue: "",

    costCenter: "",
    costCenterCode: "",
    businessUnit: "",
    businessUnitCode: "",
    budgetAvailability: "Yes",
    businessJustification: "",
    priority: "",
    priorityCode: "",
    glAccount: "",
    glAccountCode: "",
    deliveryAddress: "",

    // prStatusHeader: "",

    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    ldApplicability: "",
    ldPerDayInPercentage: "",
    downPaymentIndicator: "",
    downPaymentPercentage: "",
    dueDateForDownPayment: "",
    modeOfTransport: "",
    retention: "",

    items: [
      {
        purchasingDocumentItemNr: "",
        itemTextData: [
          {
            itemIndex: "",
            documentId: "",
            documentText: "",
          },
        ],
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        purchaseQuantity: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        netValue: "",
        deliveryDate: "",
        itemCurrency: "",
        plant: "",
        storageLocn: "",
        taxCode: 0,
        taxAmount: 0,
      },
    ],
  });

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };

  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  const [getLoader, setLoader] = useState(true);

  // Inital Create PO
  let POLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.materialCode}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        // <TextAreaField
        //   className="inputBox mt-1"
        //   name="materialDescription"
        //   placeholder=""
        //   value={row.materialDescription || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.materialDescription}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialGroup"
        //   placeholder=""
        //   value={row.materialGroup || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.materialGroup}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <>
          {/* <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        /> */}
          <span>
            {/* {row.quotationDocument[0] && row.quotationDocument[0]?.awardQty} */}
            {row.quotationDocument?.[0] && row.quotationDocument?.[0]?.awardQty}
          </span>
        </>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="orderUnitOfMeasure"
        //   placeholder=""
        //   value={row.orderUnitOfMeasure || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.orderUnitOfMeasure}</span>
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="orderPriceUnit"
        //   placeholder=""
        //   value={row.orderPriceUnit || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        // />
        <span>
          {/* {row.quotationDocument[0] &&
            row.quotationDocument[0]?.quotationUnitPrice} */}
          {row.quotationDocument?.[0] &&
            row.quotationDocument?.[0]?.quotationUnitPrice}
        </span>
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="netValue"
        //   placeholder=""
        //   value={row.netValue || 0}
        //   disabled={true}
        // />
        <span>
          {/* {row.quotationDocument[0] && row.quotationDocument[0]?.awardValue} */}
          {row.quotationDocument?.[0] && row.quotationDocument?.[0]?.awardValue}
        </span>
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          // value={row.taxAmount || 0}
          value={Number(row.taxAmount || 0).toFixed(2)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
          // onChange={(event) =>
          //   handleInputChange(row.local_id, event, "Number")
          // }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   type="date"
        //   name="deliveryDate"
        //   placeholder=""
        //   value={row.deliveryDate || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        // <InputField
        //   className="inputBox mt-1"
        //   type="date"
        //   name="deliveryDate"
        //   placeholder=""
        //   value={row.deliveryDate || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.deliveryDate}</span>
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="plant"
        //   placeholder=""
        //   value={row.plant || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.plant}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="storageLocn"
        //   placeholder=""
        //   value={row.storageLocn || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <span>{row.storageLocn}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let POLineItemInitialData = [
    {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // Inital Create Service PO
  let ServicePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.quotationUnitPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.quotationUnitPrice || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          // value={row.taxAmount || 0}
          value={Number(row.taxAmount || 0).toFixed(2)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let ServicePOLineItemInitialData = [
    {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // Inital Create Schedule PO
  let SchedulePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Schedule",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.schedule, "SE")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          // value={row.taxAmount || 0}
          value={Number(row.taxAmount || 0).toFixed(2)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let SchedulePOLineItemInitialData = [
    {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  // const [subTotalValue, setSubTotalValue] = useState(0);
  // const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  // const [getItemAmountValue, setItemAmountValue] = useState(0);

  const [getPurchaseType, setPurchaseType] = useState(0);
  const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  //Services
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");

  //Schedule
  // const [getScheduleLineItemModal, setScheduleLineItemModal] = useState(false);
  // const [getScheduleLineItemIndex, setScheduleLineItemIndex] = useState(0);
  // const [getScheduleLineItemText, setScheduleLineItemText] = useState([]);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers.map((item) =>
        item.purchasingDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  //Service PO and Schedule PO
  const handleServicePOLineItemData = (data) => {
    if (formInputs.purchaseTypeCode === "SER") {
      // let totalServiceQty = 0;
      let totalGrossValue = 0;
      let orderUnitOfMeasure = 0;

      data.map((item) => {
        // totalServiceQty += Number(item.serviceQuantity);
        totalGrossValue += Number(item.grossValue);
        orderUnitOfMeasure = item.orderUnitOfMeasure;
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item, index) => {
          return item.purchasingDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                services: data,
                purchaseQuantity: 1,
                orderPriceUnit: totalGrossValue,
                orderUnitOfMeasure: orderUnitOfMeasure,
              }
            : item;
        }),
      );
    } else {
      let totalScheduleQty = 0;

      data.map((item) => {
        totalScheduleQty += Number(item.scheduleQuantity);
        return "";
      });

      setPOLineItemsData((prevUsers) =>
        prevUsers.map((item) => {
          return item.purchasingDocumentItemNr === getServicesLineItemIndex
            ? {
                ...item,
                schedule: data,
                purchaseQuantity: totalScheduleQty,
              }
            : item;
        }),
      );
    }
  };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData,
  );
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);
  // eslint-disable-next-line no-unused-vars
  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getVendorDropdown, setVendorDropdown] = useState([]);
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getLdperdaypercentage, setLdperdaypercentage] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getLdApplicability, setLdApplicability] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getdownPaymentCategory, setdownPaymentCategory] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getmodeOfTransport, setmodeOfTransport] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getretention, setretention] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };

  /* Create PO Line Item Header Text Modal Function */
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  /* Create Header Text Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
    setDataToHeaderText();
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Text",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  /* Create Services PO Line Item Modal Function */
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };
  // filtered line Item
  const [lineItemData, setLineItemData] = useState([]);
  const [rfxQuestions, setRfxQuestions] = useState([]);

  // const filteredItems = rfxQuestions
  //   .map((item) => {
  //     const filteredQuotations = item.quotationDocument.filter(
  //       (q) => q.quotationNr === awardQuotationNr
  //     );
  //     return {
  //       ...item,
  //       quotationDocument: filteredQuotations,
  //     };
  //   })
  //   .filter((item) => item.quotationDocument.length > 0);

  // const filteredItems = rfxQuestions
  //   .map((item) => {
  //     const filteredQuotations = (item.quotationDocument || []).filter(
  //       (q) =>
  //         q.quotationNr === awardQuotationNr ||
  //         q.supplierId === awardQuotationNr ||
  //         q.supplierCode === awardQuotationNr,
  //     );
  //     return {
  //       ...item,
  //       quotationDocument: filteredQuotations,
  //     };
  //   })
  //   .filter((item) => item.quotationDocument.length > 0);

  useEffect(() => {
    if (filteredItems && filteredItems.length > 0) {
      const updatedData = filteredItems.map((item) => {
        const newItem = { ...item };

        // Map quantity, unit price, and net value from the awarded quotation document
        if (newItem.quotationDocument && newItem.quotationDocument.length > 0) {
          const doc = newItem.quotationDocument[0];
          if (doc.awardQty !== undefined)
            newItem.purchaseQuantity = doc.awardQty;
          if (doc.quotationUnitPrice !== undefined)
            newItem.orderPriceUnit = doc.quotationUnitPrice;
          if (doc.awardValue !== undefined) newItem.netValue = doc.awardValue;
        }
        // Recalculate taxAmount using the mapped quantity and price
        const qty = Number(newItem.purchaseQuantity || 0);
        const price = Number(newItem.orderPriceUnit || 0);
        const taxRate = Number(newItem.taxCode || 0);
        newItem.taxAmount = Number(
          ((taxRate / 100) * (qty * price)).toFixed(2),
        );
        // Set local ID
        newItem.local_id = item.rfxItemNr || item.local_id;
        return newItem;
      });
      setPOLineItemsData(updatedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxQuestions, awardQuotationNr]);

  // const firstSupplierId = filteredItems?.[0]?.quotationDocument?.[0]?.supplierId || "";

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.code === "SA") {
      // Schedule Agreement
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(SchedulePOLineItemInitialCol);
      setPOLineItemsData(SchedulePOLineItemInitialData);
    } else if (getDropdownData?.code === "SER") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(ServicePOLineItemInitialCol);
      setPOLineItemsData(ServicePOLineItemInitialData);
    } else if (getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(POLineItemInitialCol);
      setPOLineItemsData(POLineItemInitialData);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // const handleInputChange = (local_id, event, type) => {
  //   const { name, value } = event.target;

  //   if (type === "Number") {
  //     if (!isNaN(value)) {
  //       setPOLineItemsData((prevRows) =>
  //         prevRows.map((row) => {
  //           if (row.local_id !== local_id) return row;

  //           const updatedRow = {
  //             ...row,
  //             [name]: Number(value),
  //           };

  //           const qty = name === "purchaseQuantity" ? Number(value) : Number(row.purchaseQuantity || 0);
  //           const unitPrice = name === "quotationUnitPrice" ? Number(value) : Number(row.quotationUnitPrice || 0);
  //           const netValue = qty * unitPrice;
  //           const tax = (Number(row.taxCode || 0) / 100) * netValue;

  //           return {
  //             ...updatedRow,
  //             netValue,
  //             taxAmount: tax,
  //           };
  //         })
  //       );
  //     }
  //   } else {
  //     setPOLineItemsData((prevRows) =>
  //       prevRows.map((row) =>
  //         row.local_id === local_id ? { ...row, [name]: value } : row
  //       )
  //     );
  //   }
  // };
  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  // taxAmount:
                  //   (Number(row.taxCode) / 100) *
                  //   (name === "purchaseQuantity"
                  //     ? row.orderPriceUnit * value
                  //     : row.purchaseQuantity * value),
                  taxAmount: Number(
                    (
                      (Number(row.taxCode || 0) / 100) *
                      (name === "purchaseQuantity"
                        ? row.orderPriceUnit * value
                        : row.purchaseQuantity * value)
                    ).toFixed(2),
                  ),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  // taxAmount:
                  //   name === "taxCode"
                  //     ? (Number(value) / 100) *
                  //       (Number(row.purchaseQuantity || 0) *
                  //         Number(row.orderPriceUnit || 0))
                  //     : 0,
                  taxAmount:
                    name === "taxCode"
                      ? Number(
                          (
                            (Number(value) / 100) *
                            (Number(row.purchaseQuantity || 0) *
                              Number(row.orderPriceUnit || 0))
                          ).toFixed(2),
                        )
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  // useEffect(() => {
  //   const getItemTotal = getPOLineItemsData?.reduce(
  //     (accumulator, currentValue) =>
  //       accumulator + (currentValue?.netValue || 0),
  //     0,
  //   );
  //   const taxTotalAmount = getPOLineItemsData?.reduce(
  //     (accumulator, currentValue) =>
  //       accumulator + (currentValue?.taxAmount || 0),
  //     0,
  //   );

  //   setTaxAmountValue(taxTotalAmount);
  //   setItemAmountValue(getItemTotal);

  //   setSubTotalValue(getItemTotal + taxTotalAmount);

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getPOLineItemsData]);

  // Computed values with useMemo (0 additional renders)
  const { getItemAmountValue, getTaxAmountValue, subTotalValue } =
    useMemo(() => {
      const itemTotal = (getPOLineItemsData || []).reduce(
        (acc, curr) => acc + (Number(curr?.netValue) || 0),
        0,
      );
      const taxTotal = (getPOLineItemsData || []).reduce(
        (acc, curr) => acc + (Number(curr?.taxAmount) || 0),
        0,
      );
      return {
        getItemAmountValue: itemTotal,
        getTaxAmountValue: taxTotal,
        subTotalValue: itemTotal + taxTotal,
      };
    }, [getPOLineItemsData]);

  // useEffect(() => {
  //   getMasterDataFunc();
  //   // if (purchaseDocType) {

  //   // }
  //   //  else {
  //   //   navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const [getPurchaseDocType, setPurchaseDocType] = useState();

  //Load Master Data
  // const getMasterDataFunc = async () => {
  //   // 1
  //   let obj1 = {};
  //   await ItemService.getSupplierDatail(obj1).then((item) => {
  //     if (item?.status === 200) {
  //       setVendorDropdownData(item?.data);
  //     } else {
  //       setVendorDropdownData([]);
  //       console.log(">> Error: Loading getSupplierDatail");
  //     }
  //   });

  //   // 2
  //   let obj2 = {
  //     codeType: "purchaseOrganisation",
  //   };
  //   await ItemService.getMasterData(obj2).then((item) => {
  //     if (item?.status === 200) {
  //       setPurchaseOrg(item?.data);
  //     } else {
  //       setPurchaseOrg([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj3 = {
  //     codeType: "companyCode",
  //   };
  //   await ItemService.getMasterData(obj3).then((item) => {
  //     if (item?.status === 200) {
  //       setCompanyCode(item?.data);
  //     } else {
  //       setCompanyCode([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj4 = {
  //     codeType: "INCOTerms",
  //   };
  //   await ItemService.getMasterData(obj4).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setINCOTerms(item?.data);
  //     } else {
  //       setINCOTerms([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj5 = {
  //     codeType: "currency",
  //   };
  //   await ItemService.getMasterData(obj5).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setcurrency(item?.data);
  //     } else {
  //       setcurrency([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj6 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj6).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setpaymentTerm(item?.data);
  //     } else {
  //       setpaymentTerm([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj7 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj7).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setLdApplicability(item?.data);
  //     } else {
  //       setLdApplicability([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj8 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj8).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setdownPaymentCategory(item?.data);
  //     } else {
  //       setdownPaymentCategory([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj9 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj9).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setmodeOfTransport(item?.data);
  //     } else {
  //       setmodeOfTransport([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj10 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj10).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setretention(item?.data);
  //     } else {
  //       setretention([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj11 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj11).then((item) => {
  //     // console.log('>> Check title ',item);
  //     if (item?.status === 200) {
  //       setLdperdaypercentage(item?.data);
  //     } else {
  //       setLdperdaypercentage([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj12 = {
  //     codeType: "PurchaseType",
  //   };
  //   await ItemService.getMasterData(obj12).then((item) => {
  //     if (item?.status === 200) {
  //       setPurchaseType(item?.data);
  //     } else {
  //       setPurchaseType([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj13 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj13).then((item) => {
  //     if (item?.status === 200) {
  //       setPurchaseCategory(item?.data);
  //     } else {
  //       setPurchaseCategory([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj14 = {
  //     codeType: "paymentTerm",
  //   };
  //   await ItemService.getMasterData(obj14).then((item) => {
  //     if (item?.status === 200) {
  //       setpurchaseGroup(item?.data);
  //     } else {
  //       setpurchaseGroup([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });
  //   let obj = {
  //     codeType: "PurchaseDocType",
  //   };
  //   await ItemService.getMasterData(obj).then((item) => {
  //     // console.log('>> item!',item);
  //     if (item?.status === 200) {
  //       setPurchaseDocType(item?.data);
  //     } else {
  //       setPurchaseDocType([]);
  //       console.log(">> Error: Loading getMasterData");
  //     }
  //   });

  //   setLoader(false);
  // };

  // Optimized getMasterDataFunc with Parallelization & Deduplication
  const getMasterDataFunc = async () => {
    try {
      const [
        supplierRes,
        purchaseOrgRes,
        companyCodeRes,
        incoTermsRes,
        currencyRes,
        paymentTermRes,
        purchaseTypeRes,
        purchaseCategoryRes,
        purchaseDocTypeRes,
      ] = await Promise.allSettled([
        ItemService.getSupplierDatail({}),
        ItemService.getMasterData({ codeType: "purchaseOrganisation" }),
        ItemService.getMasterData({ codeType: "companyCode" }),
        ItemService.getMasterData({ codeType: "INCOTerms" }),
        ItemService.getMasterData({ codeType: "currency" }),
        ItemService.getMasterData({ codeType: "paymentTerm" }),
        ItemService.getMasterData({ codeType: "PurchaseType" }),
        ItemService.getMasterData({ codeType: "PurchaseCategory" }),
        ItemService.getMasterData({ codeType: "PurchaseDocType" }),
      ]);

      if (
        supplierRes.status === "fulfilled" &&
        supplierRes.value?.status === 200
      ) {
        setVendorDropdownData(supplierRes.value.data || []);
      }

      if (
        purchaseOrgRes.status === "fulfilled" &&
        purchaseOrgRes.value?.status === 200
      ) {
        setPurchaseOrg(purchaseOrgRes.value.data || []);
      }

      if (
        companyCodeRes.status === "fulfilled" &&
        companyCodeRes.value?.status === 200
      ) {
        setCompanyCode(companyCodeRes.value.data || []);
      }

      if (
        incoTermsRes.status === "fulfilled" &&
        incoTermsRes.value?.status === 200
      ) {
        setINCOTerms(incoTermsRes.value.data || []);
      }

      if (
        currencyRes.status === "fulfilled" &&
        currencyRes.value?.status === 200
      ) {
        setcurrency(currencyRes.value.data || []);
      }

      if (
        paymentTermRes.status === "fulfilled" &&
        paymentTermRes.value?.status === 200
      ) {
        const paymentData = paymentTermRes.value.data || [];
        setpaymentTerm(paymentData);
        setLdApplicability(paymentData);
        setdownPaymentCategory(paymentData);
        setmodeOfTransport(paymentData);
        setretention(paymentData);
        setLdperdaypercentage(paymentData);
        setpurchaseGroup(paymentData);
      }

      if (
        purchaseTypeRes.status === "fulfilled" &&
        purchaseTypeRes.value?.status === 200
      ) {
        setPurchaseType(purchaseTypeRes.value.data || []);
      }

      if (
        purchaseCategoryRes.status === "fulfilled" &&
        purchaseCategoryRes.value?.status === 200
      ) {
        setPurchaseCategory(purchaseCategoryRes.value.data || []);
      }

      if (
        purchaseDocTypeRes.status === "fulfilled" &&
        purchaseDocTypeRes.value?.status === 200
      ) {
        setPurchaseDocType(purchaseDocTypeRes.value.data || []);
      }
    } catch (error) {
      console.error("Unexpected error in getMasterDataFunc:", error);
    }
  };

  // SAVE
  // const handleSave = async () => {
  //   // let requiredFields = [];

  //   // if (!validateRequired(getVendorDropdown.firstName)) {
  //   //   requiredFields.push("*Please Select the Vendor");
  //   //   setErrorFields(requiredFields);
  //   //   setShowFailureModal(true);
  //   //   return;
  //   // }
  //   // if (!validateRequired(formInputs.paymentTerms)) {
  //   //   requiredFields.push("*Please Select the Payment Terms");
  //   //   setErrorFields(requiredFields);
  //   //   setShowFailureModal(true);
  //   //   return;
  //   // }
  //   // if (!validateRequired(formInputs.purchaseType)) {
  //   //   requiredFields.push("*Please Select the Purchase Type");
  //   //   setErrorFields(requiredFields);
  //   //   setShowFailureModal(true);
  //   //   return;
  //   // }

  //   // if (
  //   //   typeof getPOLineItemsData[0]?.materialCode === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.purchaseQuantity === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.orderUnitOfMeasure === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.orderPriceUnit === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.deliveryDate === "undefined"
  //   // ) {
  //   //   requiredFields.push("*Alteast one PO Line item should be added.");
  //   //   setErrorFields(requiredFields);
  //   //   setShowFailureModal(true);
  //   //   return;
  //   // }

  //   // let lineItem = []
  //   formInputs.items = filteredItems;
  //   formInputs.vendorCode = getVendorDropdown.id;
  //   formInputs.vendorName = getVendorDropdown.firstName;
  //   formInputs.headerTextData = getHeaderTextSelectedData;
  //   formInputs.purchasingDocumentValue = subTotalValue;
  //   formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
  //   formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
  //   formInputs.currencyCode = getCurrencyDropdown.code;
  //   formInputs.currency = getCurrencyDropdown.codeType;
  //   formInputs.currencyDesc = getCurrencyDropdown.name;

  //   const toastId = toast.loading("Loading...", {
  //     position: "top-right",
  //   });

  //   if (formInputs._id) {
  //     delete formInputs._id;
  //     delete formInputs.version;
  //     delete formInputs.workflowActionLogs;
  //     delete formInputs.workflowCOMMActionLogs;
  //     delete formInputs.workflowTECHActionLogs;
  //   }

  //   let obj = {
  //     data: formInputs,
  //   };

  //   setDisabled(true);
  //   await ItemService.addPR(obj).then((item) => {
  //     // console.log(">> res!", item);
  //     if (item?.status === 200) {
  //       modalData.successMsg = item?.message;
  //       setModalInfo(modalData);
  //       onSuccessfullyRegistered();

  //       let materialPO = {
  //         queryName: "getMaterialPO",
  //         module: "PO",
  //       };
  //       let servicePO = {
  //         queryName: "getServicePO",
  //         module: "PO",
  //       };
  //       let schedulingAgreement = {
  //         queryName: "getSchedulingAgreement",
  //         module: "PO",
  //       };

  //       if (formInputs.purchaseTypeCode === "MAT") {
  //         dispatch(getPurchaseOrder(materialPO));
  //       } else if (formInputs.purchaseTypeCode === "SER") {
  //         dispatch(getServicePO(servicePO));
  //       } else if (formInputs.purchaseTypeCode === "SA") {
  //         dispatch(getSchedulingAgreement(schedulingAgreement));
  //       }
  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   toast.dismiss(toastId);
  //   setDisabled(false);
  // };

    // SAVE
  const handleSave = async () => {
    // 1. Clean and map line items using the Awarded Quotation values
    const cleanItems = (getPOLineItemsData || []).map((item, index) => {
      const qty = Number(item.purchaseQuantity || 0);
      const unitPrice = Number(item.orderPriceUnit || 0);
      const netVal = item.netValue !== undefined ? Number(item.netValue) : qty * unitPrice;
      const taxRate = Number(item.taxCode || 0);
      const taxAmt = item.taxAmount !== undefined 
        ? Number(item.taxAmount) 
        : Number(((taxRate / 100) * netVal).toFixed(2));

      return {
        local_id: item.local_id || index + 1,
        purchasingDocumentItemNr:
          item.purchasingDocumentItemNr || String(index + 1).padStart(3, "0"),
        purchaseReqDocumentNr:
          item.purchaseReqDocumentNr ||
          formInputs.purchaseReqDocumentNr ||
          "",

        quotationNr: awardQuotationNr || item.quotationNr || "",
        quotationDocument: [
          {
            quotationNr: awardQuotationNr || item.quotationNr || "",
            qtnVersion: item.qtnVersion || "V0",
          },
        ],

        materialCode: item.materialCode || "",
        materialDescription: item.materialDescription || "",
        materialGroup: item.materialGroup || "",
        subCategory: item.subCategory || "",
        purchaseQuantity: qty,
        orderUnitOfMeasure: item.orderUnitOfMeasure || "",
        orderPriceUnit: unitPrice,
        netValue: netVal,
        taxCode: String(item.taxCode || "0"),
        taxAmount: taxAmt,
        deliveryDate: item.deliveryDate || formInputs.purchasingDocumentDate,
        plant: item.plant || "",
        storageLocn: item.storageLocn || "",
        specification: item.specification || "",
        currencyCode: item.currencyCode || formInputs.currencyCode || "INR",
        itemCurrency: item.itemCurrency || formInputs.currencyCode || "INR",
        itemTextData: item.itemTextData || [],
        statusItem: "In Release",
        attachmentId: item.attachmentId || "",
      };
    });

    // 2. Build Clean PO Payload without RFX bloat
    const cleanPayload = {
      manualIndicator: true,
      manualRelease: true,
      initiatorName: formInputs.initiatorName || userData?.data?.firstName || "BUYER",
      initiator: formInputs.initiator || userData?.data?.userId || "BUYER",
      purchasingDocumentType:
        formInputs.purchasingDocumentType ||
        formInputs.purchasingReqDocumentType ||
        "LOC - Local Purchase Doc",
      purchasingDocumentCode:
        formInputs.purchasingDocumentTypeCode ||
        formInputs.purchasingReqDocumentTypeCode ||
        "LOC",
      purchasingReqDocumentType:
        formInputs.purchasingReqDocumentType ||
        formInputs.purchasingDocumentType ||
        "LOC - Local Purchase Doc",
      purchasingReqDocumentTypeCode:
        formInputs.purchasingReqDocumentTypeCode ||
        formInputs.purchasingDocumentTypeCode ||
        "LOC",
      purchasingDocumentCategory: "L",
      version: "V0",
      statusHeader: "In Release",

      rfxNr: rfxNr || formInputs.rfxNr || "",
      purchaseReqDocumentNr:
        cleanItems[0]?.purchaseReqDocumentNr ||
        formInputs.purchaseReqDocumentNr ||
        "",
      quotationNr: awardQuotationNr || formInputs.quotationNr || "",
      quotationNumber: awardQuotationNr || formInputs.quotationNr || "",
      qtnVersion: formInputs.qtnVersion || "V0",

      // Vendor Info
      vendorCode: getVendorDropdown?.id || formInputs.vendorCode || "",
      vendorName:
        getVendorDropdown?.firstName ||
        getVendorDropdown?.name ||
        formInputs.vendorName ||
        "",

      // Header Details
      purchasingDocumentDate:
        formInputs.purchasingDocumentDate ||
        new Date().toISOString().split("T")[0],
      purchasingOrg: formInputs.purchasingOrg || "",
      purchasingOrgCode: formInputs.purchasingOrgCode || "",
      purchasingGroup: formInputs.purchasingGroup || "",
      purchasingGroupCode: formInputs.purchasingGroupCode || "",
      companyCode: formInputs.companyCode || "",
      companyCodeCode: formInputs.companyCodeCode || "",
      companyCodeDesc: formInputs.companyCodeDesc || "",
      currency: formInputs.currency || getCurrencyDropdown?.name || "INR",
      currencyCode: formInputs.currencyCode || getCurrencyDropdown?.code || "INR",
      currencyDesc: formInputs.currencyDesc || getCurrencyDropdown?.name || "INR-Rupee",
      paymentTerms: formInputs.paymentTerms || "",
      paymentTermsCode: formInputs.paymentTermsCode || "",
      incoTerms: formInputs.incoTerms || "",
      incoTermsCode: formInputs.incoTermsCode || "",
      incoTermsLocation: formInputs.incoTermsLocation || "",

      // Financial Totals
      purchasingDocumentValue: subTotalValue,
      purchasingDocumentTaxTotalValue: getTaxAmountValue,
      purchasingDocumentItemTotalValue: getItemAmountValue,
      purchasingRemark: formInputs.purchasingRemark || "",
      headerTextData: getHeaderTextSelectedData || [],

      // Sourcing & PR Info
      businessUnit: formInputs.businessUnit || "",
      businessUnitCode: formInputs.businessUnitCode || "",
      costCenter: formInputs.costCenter || "",
      costCenterCode: formInputs.costCenterCode || "",
      glAccount: formInputs.glAccount || "",
      glAccountCode: formInputs.glAccountCode || "",
      priority: formInputs.priority || "",
      priorityCode: formInputs.priorityCode || "",
      budgetAvailability: formInputs.budgetAvailability || "Yes",
      businessJustification: formInputs.businessJustification || "",
      deliveryAddress: formInputs.deliveryAddress || "",

      // Purchase Types & Match
      purchaseType: formInputs.purchaseType || "",
      purchaseTypeCode: formInputs.purchaseTypeCode || "",
      purchaseCategory: formInputs.purchaseCategory || "",
      purchaseCategoryCode: formInputs.purchaseCategoryCode || "",
      match: formInputs.match || "",
      matchCode: formInputs.matchCode || "",
      matchDesc: formInputs.matchDesc || "",
      process: formInputs.process || "",
      processCode: formInputs.processCode || "",
      processDesc: formInputs.processDesc || "",

      // Awarded Line Items
      items: cleanItems,
    };

    const toastId = toast.loading("Creating Purchase Order...", {
      position: "top-right",
    });

    let obj = {
      data: cleanPayload,
    };

    setDisabled(true);
    console.log("Clean Payload for create PO (PR Flow):", obj);

    try {
      const item = await ItemService.addPR(obj);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (formInputs.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
        } else if (formInputs.purchaseTypeCode === "SER") {
          dispatch(getServicePO(servicePO));
        } else if (formInputs.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error creating PO:", error);
      toast.error("Failed to create Purchase Order");
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };


  // const addPOItemRow = () => {
  //   setPOLineItemsData((prevRows) => {
  //     POLineItemInitialData[0].local_id = prevRows.length + 1;
  //     POLineItemInitialData[0].purchasingDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
  //     return [...prevRows, ...POLineItemInitialData];
  //   });
  // };

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };

  // Line

  const [, /*getSupplierList*/ setSupplierList] = useState([]);

  // const handleItemData = (data) => {
  //   // console.log(">> item tech ", data);
  //   // setItemTableData(data);
  //   setFormInputs((formInputs) => ({
  //     ...formInputs,
  //     items: data,
  //   }));
  // };

  const filteredItems = useMemo(() => {
    if (!rfxQuestions || rfxQuestions.length === 0) return [];
    return rfxQuestions
      .map((item) => {
        const filteredQuotations = (item.quotationDocument || []).filter(
          (q) =>
            q.quotationNr === awardQuotationNr ||
            q.supplierId === awardQuotationNr ||
            q.supplierCode === awardQuotationNr,
        );
        return {
          ...item,
          quotationDocument: filteredQuotations,
        };
      })
      .filter((item) => item.quotationDocument.length > 0);
  }, [rfxQuestions, awardQuotationNr]);
  // 2. Memoized callback passed to child component
  const handleItemData = useCallback((data) => {
    setFormInputs((prev) => ({
      ...prev,
      items: data,
    }));
  }, []);
  const loadCommercialEvaluationData = async () => {
    if (!rfxNr) return;

    let obj = {
      queryName: "getRFXCommEvaluationDetail",
      rfxNr: rfxNr,
    };

    try {
      const [item, rfxDetailRes] = await Promise.all([
        ItemService.generateQuery(obj),
        ItemService.getRfxDocumentDetail({
          documentNumber: rfxNr,
          timeZone: "Asia/Calcutta",
        }),
      ]);

      if (item?.status === 200) {
        const data = item?.data[0]?.supplierList || [];
        const sorted = [...data].sort(
          (a, b) => a.qtnSubTotalLineItem - b.qtnSubTotalLineItem,
        );

        const valueToRank = new Map();
        let rank = 1;
        for (let i = 0; i < sorted.length; i++) {
          const value = sorted[i].qtnSubTotalLineItem;
          if (!valueToRank.has(value)) {
            valueToRank.set(value, rank);
            rank++;
          }
        }

        const rankedData = data.map((d) => {
          const itemRank = valueToRank.get(d.qtnSubTotalLineItem);
          return {
            ...d,
            lineItemRank: itemRank,
            lineItemColor: itemRank === 1 ? "green" : "red",
          };
        });

        setSupplierList(rankedData);

        const defaultValues = {
          version: "V0",
          statusHeader: "In Release",
        };

        const apiData = item.data[0] || {};
        const docData = rfxDetailRes?.data || {};

        let prData = {};
        if (docData?.rfqCreation === "PR" && docData?.items?.length > 0) {
          const prNumber = docData.items[0].purchaseReqDocumentNr;
          if (prNumber) {
            const prRes = await ItemService.getPRDetail({
              documentNumber: prNumber,
              timeZone: "Asia/Calcutta",
            });
            if (prRes?.status === 200) {
              prData = prRes.data || {};
            }
          }
        }

        const formData = {
          ...defaultValues,
          ...apiData,
          ...prData,
          ...docData,

          // 1. Document Date
          purchasingDocumentDate: new Date().toISOString().split("T")[0],

          // 2. Purchase Type
          purchaseType: docData.productType || docData.productTypeDesc || "",
          purchaseTypeCode: docData.productTypeCode || "",

          // 3. Purchase Category
          purchaseCategory:
            docData.rfxCategoryType || docData.rfxCategoryDesc || "",
          purchaseCategoryCode: docData.rfxCategoryCode || "",

          // 4. Company Code
          companyCode:
            docData.companyAddress ||
            docData.companyAddressDesc ||
            prData.companyCode ||
            "",
          companyCodeCode:
            docData.companyAddressCode || prData.companyCodeCode || "",

          // 5. INCOTerms (Safely handles Array, Object, or String)
          incoTerms:
            Array.isArray(docData.incoTerms) && docData.incoTerms.length > 0
              ? docData.incoTerms[0]?.name ||
                docData.incoTerms[0]?.description ||
                ""
              : typeof docData.incoTerms === "object" &&
                  docData.incoTerms !== null
                ? docData.incoTerms.name || docData.incoTerms.description || ""
                : docData.incoTerms ||
                  docData.INCOTerms ||
                  prData.incoTerms ||
                  "",

          incoTermsCode:
            Array.isArray(docData.incoTerms) && docData.incoTerms.length > 0
              ? docData.incoTerms[0]?.code || docData.incoTerms[0]?.id || ""
              : typeof docData.incoTerms === "object" &&
                  docData.incoTerms !== null
                ? docData.incoTerms.code || docData.incoTerms.id || ""
                : docData.INCOTermsCode ||
                  docData.incoTermsCode ||
                  prData.incoTermsCode ||
                  "",

          incoTermsLocation:
            docData.incoTermsLocation || prData.incoTermsLocation || "",

          // 6. Payment Terms
          paymentTerms: docData.paymentTerms || "",
          paymentTermsCode: docData.paymentTermsCode || "",

          // 7. Purchasing Organization
          purchasingOrg: prData.purchasingOrg || docData.purchasingOrg || "",
          purchasingOrgCode:
            prData.purchasingOrgCode || docData.purchasingOrgCode || "",

          // 8. Purchasing Group
          purchasingGroup: prData.purchasingGroup || "",
          purchasingGroupCode: prData.purchasingGroup || "",

          businessUnit: prData.businessUnit || "",
          businessUnitCode: prData.businessUnitCode || "",

          costCenter: prData.costCenter || "",
          costCenterCode: prData.costCenterCode || "",

          budgetAvailability: prData.budgetAvailability || "Yes",
          businessJustification: prData.businessJustification || "",

          priority: prData.priority || "",
          priorityCode: prData.priorityCode || "",

          glAccount: prData.glAccount || "",
          glAccountCode: prData.glAccountCode || "",

          deliveryAddress: prData.deliveryAddress || "",

          // Document Type
          purchasingDocumentType:
            prData.purchasingReqDocumentType || purchaseDocType || "",
          purchasingDocumentTypeCode:
            prData.purchasingReqDocumentCode ||
            purchaseDocCode ||
            purchaseDocType ||
            "",

          purchasingReqDocumentType:
            prData.purchasingReqDocumentType || purchaseDocType || "",
          purchasingReqDocumentTypeCode:
            prData.purchasingReqDocumentCode ||
            purchaseDocCode ||
            purchaseDocType ||
            "",

          // Purchasing Remark
          purchasingRemark:
            prData.purchasingReqRemark || apiData.purchasingRemark || "",

          // Header Text Data
          headerTextData:
            prData.headerTextData && prData.headerTextData.length > 0
              ? prData.headerTextData
              : apiData.headerTextData || [],
        };

        const awardedSupplier = data.find(
          (s) =>
            s.quotationNr === awardQuotationNr ||
            s.AssociateNumber === awardQuotationNr,
        );
        if (awardedSupplier) {
          setVendorDropdown({
            id: awardedSupplier.AssociateNumber,
            name: awardedSupplier.organisationName,
            firstName: awardedSupplier.organisationName,
          });
        }

        setFormInputs(formData);
        setHeaderTextSelectedData(formData.headerTextData || []);
        setLineItemData(item?.data || []);
        setRfxQuestions(item?.data?.[0]?.items || []);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error loading commercial evaluation data:", error);
    }
  };

  useEffect(() => {
    const loadAllInitialData = async () => {
      try {
        setLoader(true);
        // Runs Master Data and RFX/PR Data in parallel
        await Promise.all([
          getMasterDataFunc(),
          rfxNr ? loadCommercialEvaluationData() : Promise.resolve(),
        ]);
      } catch (error) {
        console.error("Error loading initial page data:", error);
      } finally {
        setLoader(false);
      }
    };

    loadAllInitialData();
    formInputs.techEvaluationStartedOn = getCurrentDate("");
    formInputs.techEvaluationPreparedOn = getCurrentDate("");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Purchase Requisition</h2>
            <p className="subText">Fill Purchase Document Details</p>
            <hr />

            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchasingDocumentType"
                              label="Document Type"
                              placeholder=""
                              data={getPurchaseDocType}
                              iconClassName="dropdownIcon"
                              name="purchasingReqDocumentType"
                              code="purchasingReqDocumentTypeCode"
                              description="purchasingReqDocumentTypeDesc"
                              setValue={
                                formInputs?.purchasingReqDocumentType || []
                              }
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentType"
                              className="inputBox"
                              label="Document type"
                              name="purchasingDocumentType"
                              code="purchasingDocumentTypeCode"
                              description="purchasingDocumentTypeDesc"
                              placeholder=""
                              value={purchaseDocType} // purchasingDocumentType
                              onChange={onInputChange}
                              // disabled={true}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="statusHeader"
                              className="inputBox"
                              label="Status"
                              name="statusHeader"
                              placeholder=""
                              value={formInputs.statusHeader}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              label="Version"
                              name="version"
                              placeholder=""
                              value={formInputs.version}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Business Unit"
                              name="businessUnit"
                              code="businessUnitCode"
                              placeholder="Select Business Unit"
                              data={getBusinessUnitOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.businessUnit || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Organization"
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={getPurchaseOrg}
                              id="purchasingOrg"
                              iconClassName="dropdownIcon"
                              name="purchasingOrg"
                              code="purchasingOrgCode"
                              description="purchasingOrgDesc"
                              setValue={formInputs?.purchasingOrg || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Group"
                              name="purchasingGroup"
                              data={getpurchaseGroup1}
                              id="purchasingGroup"
                              code="purchasingGroupCode"
                              description="purchasingGroupDesc"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.purchasingGroup || []}
                              getvalue={setDropdownData}
                              placeholder=""
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              description="purchaseTypeDesc"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={true}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseCategory"
                              label="Purchase Category"
                              placeholder=""
                              data={getPurchaseCategory}
                              iconClassName="dropdownIcon"
                              name="purchaseCategory"
                              code="purchaseCategoryCode"
                              description="purchaseCategoryDesc"
                              setValue={formInputs?.purchaseCategory || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentDate"
                              className="inputBox"
                              label="Document Date"
                              name="purchasingDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs.purchasingDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Terms"
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              description="paymentTermsDesc"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              description="incoTermsDesc"
                              setValue={formInputs?.incoTerms || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Currency"
                              placeholder=""
                              data={getcurrency}
                              id="currency"
                              iconClassName="dropdownIcon"
                              name="currency"
                              code="currencyCode"
                              description="currencyDesc"
                              setValue={
                                getCurrencyDropdown?.name || {
                                  code: "INR",
                                  name: "INR-Rupee",
                                }
                              }
                              getvalue={setCurrencyDropdown}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Cost Center"
                              name="costCenter"
                              code="costCenterCode"
                              placeholder="Select Cost Center"
                              data={getCostCenterOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.costCenter || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentItemTotalValue"
                              className="inputBox"
                              label="Item Total Amount"
                              name="purchasingDocumentItemTotalValue"
                              placeholder=""
                              value={getItemAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="totalTaxAmount"
                              className="inputBox"
                              label="Total Tax Amount"
                              name="totalTaxAmount"
                              placeholder=""
                              value={getTaxAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingReqDocumentValue"
                              className="inputBox"
                              label="Purchase Net Value"
                              name="purchasingReqDocumentValue"
                              placeholder=""
                              value={subTotalValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="purchasingReq Value"
                              id="purchasingReqDocumentValue"
                              name="purchasingReqDocumentValue"
                              placeholder=""
                              value={
                                formInputs?.purchasingReqDocumentValue || ""
                              }
                              onChange={onInputChange}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Priority"
                              name="priority"
                              code="priorityCode"
                              placeholder="Select Priority"
                              data={getPriorityOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.priority || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="GL Account"
                              name="glAccount"
                              code="glAccountCode"
                              placeholder="Select GL Account"
                              data={getGLAccountOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.glAccount || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Delivery Address"
                              name="deliveryAddress"
                              placeholder="Select Delivery Address"
                              data={getDeliveryAddressOptions}
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.deliveryAddress || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="PurchasingReq Remark"
                              id="purchasingReqRemark"
                              name="purchasingReqRemark"
                              placeholder=""
                              value={formInputs?.purchasingReqRemark || ""}
                              onChange={onInputChange}
                              // disabled={true}
                            />
                          </Col> */}
                          <>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* Diff logic for this Only */}
                              <ComboboxField
                                className="dropdownOption"
                                label="Vendor"
                                placeholder=""
                                data={getVendorDropdownData}
                                id="vendorName"
                                iconClassName="dropdownIcon"
                                name="vendorName"
                                // setValue={getVendorDropdown?.name || []}
                                setValue={
                                  getVendorDropdown?.name
                                    ? getVendorDropdown
                                    : []
                                }
                                getvalue={setVendorDropdown}
                                required={true}
                              />
                            </Col>
                          </>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="businessJustification"
                              className="inputBox"
                              label="Business Justification"
                              name="businessJustification"
                              value={formInputs.businessJustification || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="exchangeRate"
                              className="inputBox"
                              label="Exchange Rate"
                              name="exchangeRate"
                              placeholder=""
                              value={formInputs.exchangeRate}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Exchange Rate"
                              name="firstName"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="purchasingRemark"
                              className="inputBox"
                              label="Purchasing Info"
                              name="purchasingRemark"
                              placeholder=""
                              value={formInputs.purchasingRemark || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <div className="form-check mt-4 ms-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="budgetAvailability"
                                name="budgetAvailability"
                                checked={
                                  formInputs.budgetAvailability === "Yes"
                                }
                                onChange={(e) => {
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    budgetAvailability: e.target.checked
                                      ? "Yes"
                                      : "No",
                                  }));
                                }}
                                style={{
                                  cursor: "pointer",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="budgetAvailability"
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "500",
                                  marginTop: "2px",
                                }}
                              >
                                Budget Availability
                              </label>
                            </div>
                          </Col>

                          {formInputs?.purchaseType === "MAT - Material" && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Process"
                                id="process"
                                data={processOptions}
                                placeholder=""
                                value={formInputs.process || ""}
                                name="process"
                                code="processCode"
                                description="processDesc"
                                setValue={formInputs?.process || []}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other  charges table */}
                {false ? (
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible5
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility5}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">DT</span>
                          </Col>

                          <Col xs={4} md={3} lg={3}>
                            <span className="headerTitle">Document Texts</span>
                            <span className="subHeaderTitle">
                              Document texts and Specification{" "}
                            </span>
                          </Col>
                          <Col
                            xs={12}
                            md={8}
                            lg={8}
                            className="headerButtonAlign"
                          >
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={showsetHeaderText}
                              >
                                <i className="bi bi-plus-lg"></i> Add
                              </button>
                            </Col>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible5 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                // title=""
                                columns={HeaderTextColumns}
                                data={getHeaderTextSelectedData}
                                // progressPending={loading}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                selectableRows
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  []
                )}
                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">Price Schedule</span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable">
                              <i className="bi bi-file-excel"></i> Template
                            </button>
                          </Col>
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={() => {
                                alert("asd");
                              }}
                            >
                              <i className="bi bi-file-excel"></i> Upload
                            </button>
                          </Col>
                          <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable" onClick={addPOItemRow}>
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col> */}
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={getPOLineItemsCol}
                              // data={filteredItems}
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Line Item 09*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible9
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility9}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">AS</span>
                        </Col>

                        <Col xs={4} md={8} lg={7}>
                          <span className="headerTitle">Award Summary</span>
                          {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible9 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body autoScroll">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <CommLineItemTablePO
                              data={lineItemData}
                              awardQuotationNr={awardQuotationNr}
                              sendDataToParent={handleItemData}
                              pageStatus={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!getLoader && (
        <>
          <div className="pageFooter pb-5 mb-2">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
              {/* <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  //  onClick={handleModify}
                >
                  <i className="bi bi-pencil-square"></i> Modify
                </button>
              </Col> */}
            </Row>
          </div>
        </>
      )}

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Header Text"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="POHeaderTextID"
      />

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      {/* Price Shedule -> Service PO */}
      <SericesSchedulePO
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs.purchaseTypeCode}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          formInputs.purchaseTypeCode === "MAT"
            ? Constants.POCOLLABRATION_PURCHASE_ORDER_LIST
            : formInputs.purchaseTypeCode === "SER"
              ? Constants.POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST
              : formInputs.purchaseTypeCode === "SA"
                ? Constants.POCOLLABRATION_SCHEDULING_AGREEMENT
                : ""
        }
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default PurchaseRequisitionCreationPR;
